import { useState } from 'react';
import { AgButton, AgInput } from 'src/components/ui';
import { notify } from 'src/lib/notify';
import { useUpdateOrganization } from 'src/modules/entities/organization';

export function SetGS1CompanyPrefix({ gs1CompanyPrefix }: { gs1CompanyPrefix?: number | null }) {
  const { update: updateOrganization } = useUpdateOrganization({
    onCompleted: () => notify.success('Settings Updated'),
  });

  const [gs1Prefix, setGs1Prefix] = useState(String(gs1CompanyPrefix));

  const saveSettings = async () => {
    updateOrganization({ input: { gs1CompanyPrefix: parseInt(gs1Prefix) } });
  };

  return (
    <div className="flex items-end gap-4">
      <AgInput
        className="w-[300px]"
        label="GS1 Company Prefix (GCP)"
        type="number"
        value={gs1Prefix}
        onChange={(value) => setGs1Prefix(value)}
      />
      <AgButton variant="white" onPress={() => saveSettings()} isDisabled={gs1CompanyPrefix === parseInt(gs1Prefix)}>
        Save
      </AgButton>
    </div>
  );
}
